import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0c2 3 5 6 8 8-3 2-6 5-8 8-2-3-5-6-8-8 3-2 6-5 8-8m0 2.385A32.8 32.8 0 0 1 2.385 8 32.8 32.8 0 0 1 8 13.614 32.8 32.8 0 0 1 13.614 8 32.8 32.8 0 0 1 8 2.385"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarOutlinedSize16Glyph.displayName = 'HyperstarOutlinedSize16Glyph';
